module.exports = __webpack_public_path__ + "DINNextLTPro-Bold.ttf?04d4871b40401c0bce0670345bcedccf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Bold.ttf
// module id = 1417
// module chunks = 0